var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol" },
    [
      !_vm.isLoginFormVisible
        ? [
            _c("p", { staticClass: "_mt-0 _mb-2" }, [
              _vm._v(
                _vm._s(
                  _vm.Resources.Account
                    .FollowProjectWithAnAccountModalDescription
                )
              ),
            ]),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: { "data-qa": "modal-button:ContinueWithAnAccount" },
                on: { click: _vm.onLoginAction },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.Resources.Account
                        .FollowProjectWithAnAccountModalActionButton
                    ) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "_bb-2 _bc--soft _my-3" }),
            _vm._v(" "),
            _c("base-heading", { staticClass: "_mb-3", attrs: { tag: "h2" } }, [
              _vm._v(
                _vm._s(_vm.Resources.Account.FollowProjectAsGuestModalHeader)
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "_mt-0 _mb-2" }, [
              _vm._v(
                _vm._s(
                  _vm.Resources.Account.FollowProjectAsGuestModalDescription
                )
              ),
            ]),
            _vm._v(" "),
            _c("text-field", {
              attrs: {
                "display-name": "User email",
                name: "model.email",
                "data-qa": "modal-field:Email",
              },
              model: {
                value: _vm.model.email,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "email", $$v)
                },
                expression: "model.email",
              },
            }),
            _vm._v(" "),
            _c(
              "checkbox-field",
              {
                staticClass: "_my-3",
                attrs: {
                  name: "model.termsAccepted",
                  "display-name":
                    _vm.Resources.Account
                      .CompleteAccountTermsOfServiceFieldName,
                  condensed: true,
                  "data-qa": "modal-checkbox:TermsOfService",
                },
                model: {
                  value: _vm.model.termsAccepted,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "termsAccepted", $$v)
                  },
                  expression: "model.termsAccepted",
                },
              },
              [
                _c(
                  "span",
                  [
                    _c(
                      "localize",
                      {
                        attrs: {
                          resource:
                            _vm.Resources.Account
                              .CompleteAccountTermsConsentLabel,
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "gfu-link gfu-link--accent",
                            attrs: {
                              "format-key": "0",
                              href: _vm.termsOfServiceUrl,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.Resources.Account.CompleteAccountTosLink
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "gfu-link gfu-link--accent",
                            attrs: {
                              "format-key": "1",
                              href: _vm.privacyPolicyUrl,
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.Resources.Account
                                  .CompleteAccountPrivacyPolicyLink
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: {
                  display: "block",
                  "data-qa": "modal-button:FollowAsGuest",
                },
                on: { click: _vm.submit },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.Resources.Account
                        .FollowProjectAsGuestModalActionButton
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]
        : [
            _c("external-login-actions", {
              staticClass: "_mb-3",
              attrs: { "return-url": _vm.returnUrl },
              on: { success: _vm.onSuccess },
            }),
            _vm._v(" "),
            _c("login-form", {
              attrs: { "return-url": _vm.returnUrl },
              on: { success: _vm.onSuccess },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }